export default __webpack_public_path__ + "static/media/utkarsh_event.55750f12.png";